import { Outlet } from "react-router-dom";
import Navbar from "../components/common/Navbar";
import Aside from "../components/common/Aside";

const MainLayout = () => {
  return (
    <>
    
      <div className="layout">
        <Navbar />
        <Aside />
        <main className="main-content">
          <Outlet />
        </main>
      </div>
    </>
  );
};

export default MainLayout;
